<template>
	<div class="fondoModal">
		<div>
			<div style="max-width:1000px;">
				<div class="card">
					<div class="card-header">
						{{cliente}} - {{tipo}}
						<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="cerrar">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="row">
						<div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-3">
							<table class="table table-condensed table-striped text-right">
								<thead>
									<tr>
										<th class="text-left">Mes</th>
										<th>Importe</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(importe, mes) in meses" :key="mes" v-if="importe.importe !== 0">
										<td class="text-left">
											{{getMes(mes)}}
										</td>
										<td>
											{{importe.importe | currency('')}} €
										</td>
									</tr>
								</tbody>
								<tbody class="bg-dark text-white">
									<tr>
										<td class="text-left">TOTAL:</td>
										<td><b>{{importeTotal | currency('')}} €</b></td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-9">
							<chartjs-bar
								:datalabel="'Facturación ' + cliente"
								:height="200"
								:labels="labelMeses"
								:data="chartData"
								>
							</chartjs-bar>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: ['cliente', 'meses', 'tipo'],

	data () {
		return {}
	},

	created () {
		console.log(this.tipo)
		console.log(this.meses)
	},

	computed: {
		labelMeses () {
			const m = []

			for (let i in this.meses) {
				m.push(this.getMes(i))
			}

			return m
		},
		chartData () {
			const data = []

			for (let i in this.meses) {
				data.push(this.meses[i].importe)
			}
			return data
		},
		importeTotal () {
			let total = 0

			for (let i in this.meses) {
				total += this.meses[i].importe
			}

			return total
		}
	},

	methods: {
		getMes (mes) {
			const d = new Date(parseInt(mes))
			const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
			return meses[d.getMonth()] + ', ' + d.getFullYear()
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/consultas-facturacion/vue/components/porClientes/verDetalles.vue